import styled from 'styled-components';
import { CheckoutMyDetailsStyled } from '../CheckoutMyDetailsStyled';

export const CheckoutMyDetailsStyledAC = styled(CheckoutMyDetailsStyled)`

`;
